import { CampaignType } from '../promotionsV2/types/campaign';

import type * as T from './types/bonus';
import type * as F from './types/bonusApi';

/* todo: This can be removed when all promotions are unified to ms. */
export const toEpochInSec = (epoch: number): number => Math.floor(epoch / 1000);

export const parseBonusCampaign = (campagin: F.IBonusCampaign): T.BonusCampaign => {
  return {
    id: campagin.campaignId,
    campaignType: CampaignType.BonusPromo,
    code: campagin.bonusCode,

    name: campagin.campaignName,
    requestId: campagin.requestId,
    bonus: {
      id: campagin.bonusId,
      status: campagin.bonusStatus,
      noOfChips: campagin.bonusIssued,
      noOfchipsUsed: campagin.bonusUsed,
      chipValue: campagin.chipValue,
      currencyCode: campagin.currencyCode,
      expiredOn: toEpochInSec(campagin.validityDate),
      claimStartsIn: toEpochInSec(Date.now()),
      claimEndsIn: toEpochInSec(campagin.expDate),
      maxWin: campagin.maxWinningLimit,
      myWins: campagin.accumulatedWins,
      noOfchipsRemaining: campagin.bonusRemaining,
      maxBetLimit: campagin.maxBetLimit ?? Infinity,
      claimedOn: campagin.claimDate,
      transactions: {
        data: [],
        totalPages: 0,
        pageNumber: 0,
      },
    },
  };
};
